import { Avatar, Modal, Row, Col, Skeleton, Tabs, Table } from 'antd';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import LatestImage from '../../Asset/latest-image';

const { TabPane } = Tabs;

const keyToNameMap = {
    'm': 'Asset Model',
    's': 'Asset SubType',
    't': 'Asset Type',
    'mlc': 'Asset Model|Location|SubLocation',
    'ml': 'Asset Model|Location',
    'slc': 'Asset SubType|Location|SubLocation',
    'sl': 'Asset SubType|Location',
};


function groupByProperties(array, properties, propertiesKey) {
    // return new Promise((ok) => {
    const grouped = {};
    let usedAsset = [];
    array.forEach((item) => {
        // Create a key by concatenating the values of the specified properties
        const key = properties
            .map(prop => (item.hasOwnProperty(prop) && item[prop] !== undefined && item[prop] && item[prop]['_id']) ? item[prop]['_id'] : item[prop] || 'NA')
            .join('|');

        if (key === propertiesKey) {
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(item);
            usedAsset.push(item._id.toString())
        }
    });
    return { grouped, usedAsset }
    // })

}

const PvRecord = ({ data, visible, onCancel, assets, locations, clients, handleRecordAction, hideModel, authUser, defaultTab }) => {

    const [assetList, setAssetList] = useState([]);
    const [pvRecord, setPvRecord] = useState(null);
    const [assetGroup, setAssetGroup] = useState(null);
    const [pvRecordToAssetMap, setPvRecordToAssetMap] = useState(null);
    const [assetListColumns, setAssetListColumns] = useState([])

    const [keys, setKeys] = useState(null)

    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [isAlreadySaved, setIsAlreadySaved] = useState(false);
    const [savedRecord, setSavedRecord] = useState(null);


    useEffect(() => {
        if (authUser && assets) {
            const soldLocIndex = authUser.locations.findIndex(l => l.name === 'SOLD')
            setAssetList((assets || []).filter(a => a.location !== authUser.locations[soldLocIndex]['_id']))
        }
    }, [assets, authUser])

    useEffect(() => {
        if (authUser && data) {
            // console.log(data);
            const locIndex = authUser.locations.findIndex(l => l._id === data.location || '')
            const clIndex = authUser.clients.findIndex(cl => cl._id === data.client || '')
            setPvRecord({ ...data, locationName: authUser.locations[locIndex] && authUser.locations[locIndex]['name'], clientName: authUser.clients[clIndex] && authUser.clients[clIndex]['name'] })
        }
    }, [data, authUser])

    useEffect(() => {
        if (pvRecord) {
            const model = pvRecord.assetModel && pvRecord.assetModel._id
            const subType = pvRecord.equipmentSubType && pvRecord.equipmentSubType._id
            const type = pvRecord.assetType && pvRecord.assetType._id
            const location = pvRecord.location
            const client = pvRecord.client

            const _mlc_key = `${model}|${location}|${client}`
            const _ml_key = `${model}|${location}`
            const _slc_key = `${subType}|${location}|${client}`
            const _sl_key = `${subType}|${location}`
            const _m_key = `${model}`
            const _s_key = `${subType}`

            setKeys({ _mlc_key, _ml_key, _slc_key, _sl_key, _m_key, _s_key })

        }
    }, [pvRecord])

    useEffect(() => {
        if (assetList && assetList.length && keys) {
            const { _mlc_key, _ml_key, _slc_key, _sl_key, _m_key, _s_key } = keys
            // console.log(assetList);

            let allAssets = [...assetList];
            const groupedSet = new Map();
            const { grouped: mlc, usedAsset: ua1 } = groupByProperties(allAssets, ['assetModel', 'location', 'client'], _mlc_key);

            allAssets = allAssets.filter(asset => !ua1.includes(asset._id.toString()))
            const { grouped: ml, usedAsset: ua2 } = groupByProperties(allAssets, ['assetModel', 'location'], _ml_key);

            allAssets = allAssets.filter(asset => !ua2.includes(asset._id.toString()))
            const { grouped: slc, usedAsset: ua3 } = groupByProperties(allAssets, ['equipmentSubType', 'location', 'client'], _slc_key);

            allAssets = allAssets.filter(asset => !ua3.includes(asset._id.toString()))
            const { grouped: sl, usedAsset: ua4 } = groupByProperties(allAssets, ['equipmentSubType', 'location'], _sl_key);

            allAssets = allAssets.filter(asset => !ua4.includes(asset._id.toString()))
            const { grouped: m, usedAsset: ua5 } = groupByProperties(allAssets, ['assetModel'], _m_key);

            allAssets = allAssets.filter(asset => !ua5.includes(asset._id.toString()))
            const { grouped: s } = groupByProperties(allAssets, ['equipmentSubType'], _s_key);

            groupedSet.set('mlc', mlc);
            groupedSet.set('ml', ml);
            groupedSet.set('slc', slc);
            groupedSet.set('sl', sl);
            groupedSet.set('m', m);
            groupedSet.set('s', s);

            setAssetGroup(groupedSet);
        }

    }, [assetList, keys])

    useEffect(() => {
        if (assetGroup && pvRecord) {

            const mlc = assetGroup.get('mlc') || {};
            const ml = assetGroup.get('ml') || {};
            const slc = assetGroup.get('slc') || {};
            const sl = assetGroup.get('sl') || {};
            const m = assetGroup.get('m') || {};
            const s = assetGroup.get('s') || {};

            const { _mlc_key, _ml_key, _slc_key, _sl_key, _m_key, _s_key } = keys

            // console.log(_mlc_key, _ml_key, _slc_key, _sl_key, _m_key, _s_key);

            const pvRecordPropAssetMap = new Map();

            Object.keys(mlc).forEach(key => {
                if (key === _mlc_key) {
                    pvRecordPropAssetMap.set('mlc', mlc[key])
                }
            })
            Object.keys(ml).forEach(key => {
                if (key === _ml_key) {
                    pvRecordPropAssetMap.set('ml', ml[key])
                }
            })
            Object.keys(slc).forEach(key => {
                if (key === _slc_key) {
                    pvRecordPropAssetMap.set('slc', slc[key])
                }
            })
            Object.keys(sl).forEach(key => {
                if (key === _sl_key) {
                    pvRecordPropAssetMap.set('sl', sl[key])
                }
            })
            Object.keys(m).forEach(key => {
                if (key === _m_key) {
                    pvRecordPropAssetMap.set('m', m[key])
                }
            })
            Object.keys(s).forEach(key => {
                if (key === _s_key) {
                    pvRecordPropAssetMap.set('s', s[key])
                }
            })
            setPvRecordToAssetMap(pvRecordPropAssetMap)
        }
    }, [pvRecord, assetGroup])

    // useEffect(() => {
    //     pvRecordToAssetMap && pvRecordToAssetMap.forEach((value, key, map) => {
    //         console.log(key, value);
    //     })
    // }, [pvRecordToAssetMap])

    useEffect(() => {
        // const options = props.filters && props.filters['actionTaken.name'] && props.filters['actionTaken.name']['options'] && props.filters['actionTaken.name']['options']['enum']
        // console.log(options)
        setAssetListColumns(
            [
                {
                    title: 'Photo',
                    key: 'photo',
                    // Latest image thumbnail; click opens the full-image lightbox/carousel.
                    // Stop propagation so opening the lightbox doesn't select the row.
                    render: (_, record) => record && record._id
                        ? <span onClick={e => e.stopPropagation()}><LatestImage id={record._id} /></span>
                        : null,
                },
                {
                    title: 'Asset',
                    dataIndex: 'assetCode',
                    key: 'assetCode',
                },

                {
                    title: 'Location',
                    dataIndex: 'location',
                    key: 'location',
                    render: location => {
                        if (location && locations.length) {
                            const locIndex = locations.findIndex(loc => loc._id === location);
                            return locIndex >= 0 && locations[locIndex]['name']
                        }
                    },
                    // ...getColumnSearchProps('location'),
                    filters: (locations.map(l => ({ text: l.name, value: l._id }))),
                    onFilter: (value, record) => record.location.indexOf(value) === 0,
                },
                {
                    title: 'SubLocation',
                    dataIndex: 'client',
                    key: 'client',
                    render: client => {
                        if (client && clients.length) {
                            const clIndex = clients.findIndex(cl => cl._id === client);
                            return clIndex >= 0 && clients[clIndex]['name']
                        }
                    },
                    // ...getColumnSearchProps('client'),
                    filters: clients.map(c => ({ text: c.name, value: c._id })),
                    onFilter: (value, record) => record.client.indexOf(value) === 0,
                },
                {
                    title: 'Asset Model',
                    dataIndex: 'assetModel',
                    key: 'assetModel',
                    render: (assetModel) => assetModel && assetModel.name
                },
                {
                    title: 'Asset SubType',
                    dataIndex: 'equipmentSubType',
                    key: 'equipmentSubType',
                    render: (equipmentSubType) => equipmentSubType && equipmentSubType.name
                },
                {
                    title: 'Asset Type',
                    dataIndex: 'assetType',
                    key: 'assetType',
                    render: (_, record) => record && record.equipmentSubType && record.equipmentSubType.assetType && record.equipmentSubType.assetType.name
                },
            ]
        )
    }, []);

    const handleRowClick = (asset) => {
        console.log('Selected Record:', asset);
        setSelectedRowKey(asset._id);

        if (JSON.stringify(pvRecord.assetModel) !== JSON.stringify(asset.assetModel)) {

            Modal.confirm({
                title: 'Do you want to overwrite this Asset?',
                content: `PV Model will be overwritten in the Main Asset ${asset.assetCode}`,
                okText: 'Yes',
                cancelText: 'No',
                onOk: () => {
                    handleRecordAction(asset, true, 'LINK_ASSET');
                    hideModel()
                },
                onCancel: () => {
                    handleRecordAction(asset, false, 'LINK_ASSET');
                    hideModel()
                },
            });
        } else {
            handleRecordAction(asset, false, 'LINK_ASSET');
            hideModel()
        }
    };

    const rowClassName = (record) => {
        return record._id === selectedRowKey ? 'selected-row' : '';
    };

    return (
        <div>
            <Modal visible={visible} onCancel={onCancel} footer={null} centered
                bodyStyle={{ padding: 0 }}
                width="90%"
            // style={{maxWidth: '800px'}}
            >
                <div style={{
                    marginTop: '10px',
                    // position: 'relative',
                    padding: '10px',
                    // display: 'flex',
                    // flexWrap: 'wrap',
                    // justifyContent: 'space-between',
                    // wordBreak: 'break-all',
                }}>
                    <div style={{ border: '1px dashed', borderRadius: '8px', padding: '5px', fontWeight: 'bold' }}>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">Temp Code: {pvRecord && pvRecord.tempAssetCode}</div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">PV : {pvRecord && pvRecord.pvNo}</div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">Location:{pvRecord && pvRecord.location && pvRecord.locationName}</div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">SubLocation: {pvRecord && pvRecord.client && pvRecord.clientName}</div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">Model : {pvRecord && pvRecord.assetModel && pvRecord.assetModel.name}</div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">Sub Type :{pvRecord && pvRecord.equipmentSubType && pvRecord.equipmentSubType.name}</div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box">Type :{pvRecord && pvRecord.assetType && pvRecord.assetType.name}</div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box"></div>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        {pvRecordToAssetMap &&
                            <Tabs tabPosition={'left'} style={{ height: '45%' }} defaultActiveKey={defaultTab || undefined}>
                                {
                                    Array.from(pvRecordToAssetMap).map(([key, value]) => (
                                        <TabPane tab={`${keyToNameMap[key]}`} key={key}>
                                            <Table dataSource={value} columns={assetListColumns} rowClassName={rowClassName} onRow={(record) => ({
                                                onClick: () => handleRowClick(record),
                                            })} />
                                        </TabPane>
                                    ))
                                }
                            </Tabs>
                        }

                    </div>


                </div>

            </Modal>
        </div>
    )
}


export default PvRecord